import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Lightning20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.2334 1.15714L11.9277 7.25H16C16.6107 7.25 16.9669 7.97531 16.5935 8.45858L8.09347 19.4586C7.61771 20.0743 6.60362 19.6037 6.76666 18.8428L8.07227 12.75H4.00001C3.38927 12.75 3.03311 12.0247 3.40655 11.5414L11.9065 0.541409C12.3823 -0.0742836 13.3964 0.396321 13.2334 1.15714ZM5.52738 11.25H9.92775L8.92506 15.9292L14.4726 8.75H10.0723L11.075 4.07078L5.52738 11.25Z'
      fill='currentColor'
    />
  </Svg>
);

Lightning20.displayName = 'Lightning20';
export default Lightning20;
